import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { getCommentList } from "../../api/api";
import CommentTable from "./components/commentTable/commentTable";
import "./index.css";

const { RangePicker } = DatePicker;

const CommentManage = () => {
  const [componentSize, setComponentSize] = useState("default");
  const [payload, setPayload] = useState({ page: "1", pagesize: "10" });
  const [total, setTotal] = useState(0);
  const [isFresh, setIsFresh] = useState(false);

  const [form] = Form.useForm();
  const commentTableRef = useRef();
  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size);
  };

  useEffect(() => {
    getCommentList({ params: payload }).then((res) => {
      const info = res.data.data;
      if (info.total === 0) {
        message.error("未能找到指定条件内容！");
      }

      commentTableRef.current.changeData(res.data.data.rows);
      setTotal(res.data.data.total);
    });
  }, [payload, isFresh]);

  const pageChange = (e) => {
    //分页改变时的回调函数
    setPayload({
      ...payload,
      page: e,
    });
  };
  //重置选项
  const resetSelectors = () => {
    form.resetFields();
  };

  const handleSubmit = (values) => {
    let payload = {
      page: "1",
      pagesize: "10",
      post_content: values.post_content,
      thread_content: values.thread_content,
      audit_status: values.audit_status,
    };
    let start = values?.date[0];
    let end = values?.date[1];

    if (start !== "") {
      payload["period_start"] = moment(start).format("YYYY-MM-DD");
    }
    if (end !== "") {
      payload["period_end"] = moment(end).format("YYYY-MM-DD");
    }
    // console.log(payload)
    setPayload(payload);
  };
  return (
    <div className="commentManage">
      <Form
        initialValues={{
          size: componentSize,
          date: ["", ""],
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        className="commentSelectors"
        form={form}
      >
        <Row>
          <Col span={10}>
            {" "}
            <Form.Item
              label="评论信息"
              name="thread_content"
              className="commentContent"
              // labelCol={{ span: 6 }}
            >
              <Input placeholder="请输入评论编号/评论人昵称/手机" />
            </Form.Item>
          </Col>
          <Col span={12} offset={1}>
            {" "}
            <Form.Item
              label="帖子信息"
              name="post_content"
              className="commentInfo"
            >
              <Input placeholder="请输入帖子序号/帖子标题" />
            </Form.Item>
          </Col>
          <Col span={10}>
            {" "}
            <Form.Item label="评论时间" name="date" className="commentTime">
              <RangePicker />
            </Form.Item>
          </Col>
          <Col span={7}>
            {" "}
            <Form.Item
              label="状态"
              name="audit_status"
              className="commentType"
              labelCol={{ span: 9 }}
            >
              <Select
                mode="multiple"
                placeholder="请选择审核状态"
                style={{ textAlign: "left" }}
                getPopupContainer={(e) => e}
              >
                <Select.Option value={1}>待审核</Select.Option>
                <Select.Option value={2}>审核通过</Select.Option>
                <Select.Option value={3}>审核不通过</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={7}>
            <div className="selector_button">
              <Button onClick={resetSelectors}>重置</Button>
              <Form.Item
                wrapperCol={{
                  span: 12,
                  offset: 6,
                }}
              >
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Form>
      <CommentTable ref={commentTableRef} setIsFresh={setIsFresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: "right" }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  );
};
export default CommentManage;
